
export interface PowernovaValueModel {
    type: string;
    soundId: string;
    uiText: string;
    model: string;
    audioService: string;
    name: string;
    isAppointment: boolean;
    containsAppointment: string;
    src: string;
    canPreview: boolean;
}

export const soundSoundIdURL = '/servlets/audio/sound/play/';
export const soundTTSUrl = '/servlets/audio/tts/play/?tts=';

export const callScripts = {
    handleScript: {
        companyIntro: {
            uiText: 'This is a message from your doctor',
            type: undefined,
            isForNormal: true,
            isForVoicemail: true,
            model: undefined
        },
        companyIntro2: {
            uiText: 'This is a message from your doctor',
            type: undefined,
            isForNormal: true,
            isForVoicemail: true,
            model: undefined
        },
        press1spanish: {
            uiText: 'Press 1 to listen to the message in Spanish',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: false
        },
        to: {
            uiText: 'The message is for',
            type: undefined,
            isForNormal: true,
            isForVoicemail: true,
            model: undefined
        },
        firstName: {
            type: 'tts',
            model: 'template.voiceFirstNameTTS',
            isForNormal: true,
            isForVoicemail: true
        },
        regarding: {
            uiText: 'We would like to remind you that you have appointment',
            type: undefined,
            isForNormal: true,
            isForVoicemail: false,
            model: undefined
        },
        regarding2: {
            uiText: 'We would like to remind you that you have appointment',
            type: undefined,
            isForNormal: true,
            isForVoicemail: false,
            model: undefined
        },
        regardingVoicemail: {
            uiText: 'We would like to remind you that you have appointment',
            type: undefined,
            isForNormal: false,
            isForVoicemail: true,
            model: undefined
        },
        regardingVoicemail2: {
            uiText: 'We would like to remind you that you have appointment',
            type: undefined,
            isForNormal: false,
            isForVoicemail: true,
            model: undefined
        },
        location: {
            uiText: 'Location',
            type: undefined,
            isForNormal: true,
            isForVoicemail: true,
            model: undefined
        },
        location2: {
            uiText: 'Location',
            type: undefined,
            isForNormal: true,
            isForVoicemail: true,
            model: undefined
        },
        todayTomorrow: {
            uiText: 'today tomorrow',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: true,
            containsAppointment: 'start',
            isAppointment: true
        },

        dayOfWeek: {
            uiText: 'Friday',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: true,
            containsAppointment: '',
            isAppointment: true
        },
        the: {
            uiText: 'the',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: true,
            isAppointment: true
        },
        dayOfMonth: {
            uiText: '1st',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: true,
            isAppointment: true
        },
        of: {
            uiText: 'of',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: true,
            isAppointment: true
        },
        nameOfMonth: {
            uiText: 'January',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: true,
            isAppointment: true
        },
        at: {
            uiText: 'at',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: true,
            isAppointment: true
        },
        hour: {
            uiText: '9',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: true,
            isAppointment: true
        },
        minutes: {
            uiText: '30',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: true,
            isAppointment: true
        },
        ampm: {
            uiText: 'AM',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: true,
            containsAppointment: 'end',
            isAppointment: true
        },
        instruction: {
            uiText: 'We require that you contact us 24hours before your appointment if you need to cancel or reschedule.' +
                'Our number is xxxxxx',
            type: undefined,
            isForNormal: true,
            isForVoicemail: false,
            model: undefined
        },
        instruction2: {
            uiText: 'We require that you contact us 24hours before your appointment if you need to cancel or reschedule.' +
                'Our number is xxxxxx',
            type: undefined,
            isForNormal: true,
            isForVoicemail: false,
            model: undefined
        },
        instructionVoicemail: {
            uiText: 'We require that you contact us 24hours before your appointment if you need to cancel or reschedule.' +
                'Our number is xxxxxx',
            type: undefined,
            isForNormal: false,
            isForVoicemail: true,
            model: undefined
        },
        instructionVoicemail2: {
            uiText: 'We require that you contact us 24hours before your appointment if you need to cancel or reschedule.' +
                'Our number is xxxxxx',
            type: undefined,
            isForNormal: false,
            isForVoicemail: true,
            model: undefined
        },
        press1repeat: {
            uiText: 'Press 1 to listen to the message again',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: false
        },
        press5confirm: {
            uiText: 'Press 5 to confirm your appointment',
            type: 'voice',
            isForNormal: true,
            isForVoicemail: false
        },
        goodbye: {
            uiText: 'Thank you and goodbye',
            type: undefined,
            isForNormal: true,
            isForVoicemail: true,
            model: undefined
        },
        companyOutro: {
            uiText: 'This is a message from your doctor',
            type: undefined,
            isForNormal: true,
            isForVoicemail: true,
            model: undefined
        }

    }
};
